import { useContext, useState } from 'react';
import {
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormGroup,
  FormControlLabel,
  Switch,
} from '@mui/material';

import { AuthContext, stopPropagationForTab } from 'components';
import { Tracking } from 'components/Tracking';
import { useNavigate } from "react-router-dom";


export const BulkModal = (props) => {
  const { items, onClose, selected } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [ saving, setSaving ] = useState(false);
  const [ value, setValue ] = useState(true)
  const { updateItem } = useContext(AuthContext);


  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    navigate("/products_reload");
    if (onClose) {
      onClose();
    }
  }

  const handleSave = () => {
    Tracking.track('Portal - Bulk edit Commited', { items: items.length })
    let bulk_update = []
    console.log('saving', saving)

    items.forEach((item) => {
      let values = {
        orderStatus: value ? 1 : 0
      }

      if (!value) {
        values.deliveries = 0
      }

      bulk_update.push(new Promise((resolve, rejejct) => {
        updateItem(
          item,
          values,
          resolve
        )
      }))
    })

    Promise.all(bulk_update).then(() => {
      handleClose()
    })
  }

  
  return (
    <>
      <MenuItem disabled={!selected} onClick={handleOpen}>
        <div>Commited/Undecided</div>
      </MenuItem>
      <Dialog onKeyDown={stopPropagationForTab} open={open} onClose={handleClose}>
        <DialogTitle>Set Commited</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Change commitment of all of your selected items
          </DialogContentText>
          {/*  */}
          <FormGroup>
            <FormControlLabel 
              control={
                <Switch 
                  checked={value}
                  onChange={(e) => setValue(e.target.checked)}
                  defaultChecked 
                />
              }
              label="Commited" 
              labelPlacement="start"
            />
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={saving} onClick={() => { setSaving(true); setTimeout(handleSave, 200) }}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}